import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { WorkItemsService } from '@app/services/work-items/work-items.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-job-check',
  templateUrl: './job-check.component.html',
  styleUrls: ['./job-check.component.scss']
})
export class JobCheckComponent {

  constructor(public modalRef: BsModalRef, private workItem: WorkItemsService, private router: Router) {

    
  }
  homeAction() {
    this.workItem.canNavigate = true;
    this.workItem.jobStatus = 'COMPLETED';
    this.router.navigate(['template2/default']);
    this.modalRef.hide();
  }

  newJob() {
    this.modalRef.hide();
    this.workItem.getNewJob()
  }

}
